module.exports = __webpack_public_path__ + "static/media/computer-dynamic-premium.fe01cc86.png";